module.exports = __webpack_public_path__ + "static/z-8g-b32cf588c7a7d4a014ebc5131c93aa7b.jpg";